import { createFileRoute } from "@tanstack/react-router";
import { FloatingLeftButton } from "@/components/FloatingLeftButton";
import TermsContent from "./content.mdx";

function TermsOfService() {
  return (
    <div
      className="min-h-screen w-full relative bg-white"
      style={{ fontFamily: "'Onest', Helvetica, Arial, sans-serif" }}
    >
      <FloatingLeftButton
        onClick={() => window.history.back()}
        className="absolute left-0 top-4 z-50"
        icon={
          <svg
            className="w-4 h-4"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 1V0H2V1H1V2H0V3H1V4H2V5H3V4H6V7H3V8H7V7H8V6H9V3H8V2H7V1H3Z"
              fill="white"
            />
          </svg>
        }
      />

      <div className="p-4 mt-8 mdx-content">
        <TermsContent />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/terms-of-service/")({
  component: TermsOfService,
});
